import _ from "lodash";

export function getQueryParams(params) {
  
    const result = {};
    if (params.has("neighborhood")) {
      result.neighborhoodValue = params.get("neighborhood");
    }
    if (params.has("document")) {
        result.docTypeValue = params.get("document");
    }
    if (params.has("search")) {
        result.searchText = params.get("search");
    }
    if (params.has("project")) {        /// For the future since right now the project filter is a map of id and name
        result.projId = params.get("project");
    };
      
    if (params.has("startDate")) {
      const start = new Date(params.get("startDate") +"T23:59:59");
      if (!isNaN(start.getTime())) {
        result.startDate = start;
      }
    }

    if (params.has("endDate")) {
      const end = new Date(params.get("endDate")+"T23:59:59");
      if (!isNaN(end.getTime())) {
        result.endDate = end;
      }
    }
    return result;
  }
export function normalizeFilterValue(inputValue, options, returnWholeObject = false) { /// value from query string, dropdown list values 
  if (!inputValue || !Array.isArray(options)) return returnWholeObject ? null : '';

   // Normalize input to an array
  const values = typeof inputValue === 'string'
    ? inputValue.split(',').map(v => v.trim()).filter(v => v)
    : Array.isArray(inputValue)
    ? inputValue
    : [];
  const matches = values.map(val => {
    console.log("values", val);
    const match = options.find(opt => opt.name?.toLowerCase() === val.toLowerCase());
    console.log("values", match);
    return match ? (returnWholeObject ? match : match.name) : (returnWholeObject ? null : val);
  }).filter(Boolean); // remove nulls if returnWholeObject is true

  return returnWholeObject ? matches : matches.join(',');
}
